import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import RegisterIcon from './RegisterIcon.jsx';
import { getFederationName } from './federationNameStrings.js';
import emailIcon from '../../ASUPhotos/icons/me3_SSO_Envelope.svg';
import humanIcon from '../../ASUPhotos/icons/me3_SSO_Register.svg';
import socialIcon from '../../ASUPhotos/icons/me3_SSO_SocialIcon.svg';

const registrationTypeStyles = {
  color: () => ({
    color: 'black',
  }),
};

function RegistrationType(props) {
  const { t } = useTranslation();
  const { registrationType, tenantName } = { ...props };

  const registrationTypeIconIDMap = {
    email: emailIcon,
    federation: humanIcon,
    social: socialIcon,
  };

  const registrationTypeTextIDMap = {
    email: t('Email'),
    federation: getFederationName(tenantName.toUpperCase()),
    social: t('Social'),
  };

  return (
    <div className="registration-type">
      <RegisterIcon
        iconImage={registrationTypeIconIDMap[registrationType]}
        ariaLabelText="icon for different types of registration"
      />
      <p className={classNames('registration-source', props.classes.color)}>
        {registrationTypeTextIDMap[registrationType]}
      </p>
    </div>
  );
}

export default withStyles(registrationTypeStyles)(RegistrationType);
